import WSConnectManager from "@/pages/WebSocketConnect";

// Single Pages
import AuthLayout from "@/pages/Auth/AuthLayout.vue";
import Login from "@/pages/Auth/Login.vue";
import EditProfile from "@/pages/User/EditProfile.vue";


//Devices
import WSDevicesManager from "@/pages/Devices/WSDevicesManager.vue";
import DashboardLayout from "@/pages/Devices/Layout/DevicesLayout.vue";

//Visualization
//Profile
import VoltageProfile from "@/pages/Devices/Visualization/profiles/Voltage.vue";
import CurrentProfile from "@/pages/Devices/Visualization/profiles/Current.vue";
import ActivePower from "@/pages/Devices/Visualization/profiles/ActivePower.vue";
import ReactivePower from "@/pages/Devices/Visualization/profiles/ReactivePower.vue";
import ApparentPower from "@/pages/Devices/Visualization/profiles/ApparentPower.vue";
import EnergyImport from "@/pages/Devices/Visualization/profiles/EnergyImport";
import EnergyExport from "@/pages/Devices/Visualization/profiles/EnergyExport";
//AppliedPrecision
import ReactiveEnergyProfile from "@/pages/Devices/Visualization/profiles/ReactiveEnergy";
import ApparentEnergyProfile from "@/pages/Devices/Visualization/profiles/ApparentEnergy";
import FrequencyProfile from "@/pages/Devices/Visualization/profiles/Frequency";
import PowerFactorProfile from "@/pages/Devices/Visualization/profiles/PowerFactor";
import DistorationFactorVoltageProfile from "@/pages/Devices/Visualization/profiles/DistorationFactorVoltage";
import DistorationFactorCurrentProfile from "@/pages/Devices/Visualization/profiles/DistorationFactorCurrent";

//Energy
import Energy15MinMaximum from "@/pages/Devices/Visualization/energy/Energy15MinMaximum";
import Energy15Min from "@/pages/Devices/Visualization/energy/Energy15Min";
import EnergyHour from "@/pages/Devices/Visualization/energy/EnergyHour";
import EnergyDay from "@/pages/Devices/Visualization/energy/EnergyDay";
import EnergyMonth from "@/pages/Devices/Visualization/energy/EnergyMonth";
import ReactiveDay from "@/pages/Devices/Visualization/energy/ReactiveDay";

//RealTime
import RealTimeDataManager from "@/pages/Devices/Visualization/realtime/RealtimeDataManager"
import RealTimeVoltage from "@/pages/Devices/Visualization/realtime/Voltage"
import RealTimeCurrent from "@/pages/Devices/Visualization/realtime/Current"
import RealTimeActivePower from "@/pages/Devices/Visualization/realtime/ActivePower"
import RealTimeReactivePower from "@/pages/Devices/Visualization/realtime/ReactivePower"
import RealTimeApparentPower from "@/pages/Devices/Visualization/realtime/ApparentPower"
import RealTimeEnergyImport from "@/pages/Devices/Visualization/realtime/EnergyImport"
import RealTimeEnergyExport from "@/pages/Devices/Visualization/realtime/EnergyExport"
//AppliedPrecision
import RealTimeFrequency from "@/pages/Devices/Visualization/realtime/Frequency"
import RealTimePowerFactor from "@/pages/Devices/Visualization/realtime/PowerFactor"
import RealTimeDistortionFactorVoltage from "@/pages/Devices/Visualization/realtime/DistortionFactorVoltage"
import RealTimeDistortionFactorCurrent from "@/pages/Devices/Visualization/realtime/DistortionFactorCurrent"
import RealTimeReactiveEnergy from "@/pages/Devices/Visualization/realtime/ReactiveEnergy"
import RealTimeApparentEnergy from "@/pages/Devices/Visualization/realtime/ApparentEnergy"


//Applications
import ApplicationsLayout from "@/pages/Applications/Layout/ApplicationsLayout"
import WSApplicationsManager from "@/pages/Applications/Pages/WSManager"

//UserManager
import userManager from "@/pages/Applications/Pages/UserManager/UserManager"

//Tools
import Monitoring from "@/pages/Devices/Tools/Monitoring"
import Notifications from "@/pages/Devices/Tools/Notifications"


//AppliedPrecision
import precisionDashboard from "@/pages/Devices/AppliedPrecision/Dashboard"
import ap_addMeter from "@/pages/Devices/AppliedPrecision/AddMeter/AddMeter"
import ap_meters from "@/pages/Devices/AppliedPrecision/MetersList/Meters"
import ap_meter_error from "@/pages/Devices/AppliedPrecision/TestList/MeterError/MeterError"
import ap_vectorDiagram from "@/pages/Devices/AppliedPrecision/VectorDiagram/VectorDiagram"
import ap_harmonicsChart from "@/pages/Devices/AppliedPrecision/HarmonicsChart"
import ap_waveformChart from "@/pages/Devices/AppliedPrecision/WaveformChart"



import { getDeviceList } from '@/storage/memoryStorage';
import store from '@/storage/store';
import config from "@/config/config";


function getAuth() {
  return store.getters.getAuth;
}

function selectedDevice() {
  return store.getters.getSelectedDevice;
}

function isSignedIn() {
  try {
    if ((getAuth().expiration > new Date().getTime()) && getDeviceList().length > 0) {
      return true;
    }
  } catch (err) {
    return false;
  }
  return false;
}

function requireAuth(to, from, next) {

  if (!isSignedIn()) {
    next({
      path: '/login'
    });
  } else {
    next();
  }
}

function visualizationAccess(to, from, next) {
  try {
    if (
      selectedDevice().type == config.devices.precision.id) 
      {
      next();
    } else {
      next(handleRedirect());
    }
  } catch {
    next(handleRedirect());
  }
}

function deviceAccess(to, from, next, deviceType) {
  try {
    if (selectedDevice().type == deviceType) {
      next();
    } else {
      next(handleRedirect());
    }
  } catch {
    next(handleRedirect());
  }
}

function ownerAccess(to, from, next) {
  try {
    if (selectedDevice().owner === true) {
      next();
    } else {
      next(handleRedirect());
    }
  } catch {
    next(handleRedirect());
  }
}

function NILMAccess(to, from, next) {
  try {
    if (selectedDevice().NILM == true) {
      next();
    } else {
      next(handleRedirect());
    }
  } catch {
    next(handleRedirect());
  }
}

function userAccess(to, from, next) {
  try {
    if (getAuth().id === 1 && getAuth().user !== 'demo') {
      next();
    } else {
      next(handleRedirect());
    }
  } catch {
    next(handleRedirect());
  }
}

function applicationAccess(to, from, next) {
  try {
    if (getAuth().applications.length > 0) {
      next();
    } else {
      next(handleRedirect());
    }
  } catch {
    next(handleRedirect());
  }
}



// function appAcces(to, from, next, application) {
//   try {
//     if (getAuth().applications.findIndex(app => app === application) != -1) {
//       next();
//     } else {
//       next(handleRedirect());
//     }
//   } catch {
//     next(handleRedirect());
//   }
// }

import { getUserToken } from "@/storage/memoryStorage";
import axios from "axios";
import Vue from 'vue'

function appAcces(to, from, next, application) {
  axios({
    method: "POST",
    url: Vue.prototype.$ENDPOINTS.API_R + "/applications/access",
    data: {
      user_token: getUserToken(),
      application: application,
    },
    withCredentials: true
  })
    .then(response => {
      next();
    })
    .catch(error => {
      next(handleRedirect());
    });
}

export function handleRedirect() {
  if (!isSignedIn()) {
    return "/login";
  } else {
    
      return "/applied-precision/dashboard";
    
  }
}


const devicesVisualization = {
  path: "/visualization",
  component: DashboardLayout,
  redirect: "visualization/dashboard",
  beforeEnter: (to, from, next) => {
    requireAuth(to, from, next);
    visualizationAccess(to, from, next);
  },
  children: [
    {
      path: "realtime",
      component: RealTimeDataManager,
      redirect: "realtime/voltage",
      children: [
        {
          path: "voltage",
          name: "realtime_voltage",
          components: { default: RealTimeVoltage }
        },
        {
          path: "current",
          name: "realtime_current",
          components: { default: RealTimeCurrent }
        },
        {
          path: "power/active",
          name: "realtime_active_power",
          components: { default: RealTimeActivePower }
        },
        {
          path: "power/reactive",
          name: "realtime_reactive_power",
          components: { default: RealTimeReactivePower }
        },
        {
          path: "power/apparent",
          name: "realtime_apparent_power",
          components: { default: RealTimeApparentPower }
        },
        {
          path: "energy/import",
          name: "realtime_energy_import_profile",
          components: { default: RealTimeEnergyImport }
        },
        {
          path: "frequency",
          name: "realtime_frequency",
          components: { default: RealTimeFrequency }
        },
        {
          path: "power-factor",
          name: "realtime_powerfactor",
          components: { default: RealTimePowerFactor }
        },
        {
          path: "distortion-factor/voltage",
          name: "realtime_distortion_factor_voltage",
          components: { default: RealTimeDistortionFactorVoltage }
        },
        {
          path: "distortion-factor/current",
          name: "realtime_distortion_factor_current",
          components: { default: RealTimeDistortionFactorCurrent }
        },
        {
          path: "energy/reactive",
          name: "realtime_reactive_energy",
          components: { default: RealTimeReactiveEnergy }
        },
        {
          path: "energy/apparent",
          name: "realtime_apparent_energy",
          components: { default: RealTimeApparentEnergy }
        }
      ]
    },
    {
      path: "profile/voltage",
      name: "voltage_profile",
      components: { default: VoltageProfile }
    },
    {
      path: "profile/current",
      name: "current_profile",
      components: { default: CurrentProfile }
    },
    {
      path: "profile/power/active",
      name: "active_power_profile",
      components: { default: ActivePower }
    },
    {
      path: "profile/power/reactive",
      name: "reactive_power_profile",
      components: { default: ReactivePower }
    },
    {
      path: "profile/power/apparent",
      name: "apparent_power_profile",
      components: { default: ApparentPower }
    },
    {
      path: "profile/energy/import",
      name: "energy_import_profile",
      components: { default: EnergyImport }
    },
    {
      path: "profile/energy/reactive",
      name: "energy_reactive_profile",
      components: { default: ReactiveEnergyProfile }
    },
    {
      path: "profile/energy/apparent",
      name: "energy_apparent_profile",
      components: { default: ApparentEnergyProfile }
    },
    {
      path: "profile/frequency",
      name: "frequency_profile",
      components: { default: FrequencyProfile }
    },
    {
      path: "profile/power-factor",
      name: "power_factor_profile",
      components: { default: PowerFactorProfile }
    },
    {
      path: "profile/distoration-factor/voltage",
      name: "profile_distoration_factor_voltage",
      components: { default: DistorationFactorVoltageProfile }
    },
    {
      path: "profile/distoration-factor/current",
      name: "profile_distoration_factor_current",
      components: { default: DistorationFactorCurrentProfile }
    },
    {
      path: "energy/active/15min/maximum",
      name: "maximum_active_energy_15min",
      components: { default: Energy15MinMaximum }
    },
    {
      path: "energy/active/15min",
      name: "active_energy_15min",
      components: { default: Energy15Min }
    },
    {
      path: "energy/active/hour",
      name: "hourly_active_energy",
      components: { default: EnergyHour }
    },
    {
      path: "energy/active/day",
      name: "daily_active_energy",
      components: { default: EnergyDay }
    },
    {
      path: "energy/active/month",
      name: "monthly_active_energy",
      components: { default: EnergyMonth }
    },
    {
      path: "energy/reactive/day",
      name: "daily_reactive_energy",
      components: { default: ReactiveDay }
    }
  ]
};



const applications = {
  name: "applications_default",
  path: "applications",
  component: ApplicationsLayout,
  redirect: to => {
    if (getAuth().applications.length > 0) {
        
         for(let i=0;i<getAuth().applications.length ; i++)
         {
           switch(getAuth().applications[i]){
         
            case "USER_MANAGER":
            return { path: "/applications/user-manager"};
            
           }
        }
       return { path: "/applications"};
    } else {
      return { path: handleRedirect() };
    }
  } ,
  beforeEnter: (to, from, next) => {
    requireAuth(to, from, next);
    applicationAccess(to, from, next);
  },
  children: [
    {     
      path: "",
      name: "apps_default",
      components: { default: userManager },
      beforeEnter: (to, from, next) => {
        appAcces(to, from, next, "USER_MANAGER");
      }
    },
     {
      path: "user-manager",
      name: "user_manager",
      components: { default: userManager },
      beforeEnter: (to, from, next) => {
        appAcces(to, from, next, "USER_MANAGER");
      }
    },


    
  ]
};


const domainAppliedPrecision = {
  path: "/applied-precision",
  component: DashboardLayout,
  redirect: "applied-precision/dashboard",
  beforeEnter: (to, from, next) => {
    requireAuth(to, from, next);
    deviceAccess(to, from, next, config.devices.precision.id);
  },
  children: [
    {
      path: "",
      component: RealTimeDataManager,
      redirect: "applied-precision/dashboard",
      children: [
        {
          path: "dashboard",
          name: "dashboard_precision",
          components: { default: precisionDashboard }
        },
        {
          path: "vector",
          name: "vector_chart",
          components: { default: ap_vectorDiagram }
        },
      ]
    },
    {
      path: "meters",
      name: "meters_list",
      components: { default: ap_meters }
    },
    {
      path: "meter/add",
      name: "meter_add",
      components: { default: ap_addMeter }
    },
    {
      path: "meter/tests/:meter_id",
      name: "meter_tests",
      components: { default: ap_meter_error }
    },
    {
      path: "harmonics",
      name: "harmonics_chart",
      components: { default: ap_harmonicsChart }
    },
    {
      path: "waveform",
      name: "wavefrom_chart",
      components: { default: ap_waveformChart }
    }
  ]
}


const toolsMenu = {
  path: "tools",
  component: DashboardLayout,
  redirect: "tools/monitoring",
  beforeEnter: requireAuth,
  children: [
    {
      path: "monitoring",
      name: "monitoring",
      components: { default: Monitoring }
    },
    {
      path: "notifications",
      name: "notifications",
      components: { default: Notifications }
    }
  ]
};


const singlePages = {
  path: "user",
  component: DashboardLayout,
  redirect: handleRedirect,
  children: [
    {
      path: "edit-profile",
      name: "edit_profile",
      components: { default: EditProfile },
      beforeEnter: (to, from, next) => {
        requireAuth(to, from, next);
        userAccess(to, from, next);
      },
    }
  ]
};


const authPages = {
  path: "/login",
  component: AuthLayout,
  children: [
    {
      path: "",
      name: "Login",
      component: Login
    }
  ]
};

const routes = [
  {
    path: "",
    component: WSConnectManager,
    name: "WSConnect",
    children: [
      {
        path: "",
        component: WSDevicesManager,
        redirect: "/login",
        name: "Devices",
        children: [
          devicesVisualization,
          domainAppliedPrecision,
          toolsMenu,
          singlePages,
        ]
      },
       {
        path: "",
        component: WSApplicationsManager,
        name: "Applications",
        children: [
          applications
        ]
      }
    ]
  },
  authPages,

  //DEFAULT ROUTE TODO: 404
  { path: "*", redirect: handleRedirect }
];

export default routes;
